<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="formCard">
      <b-card-text>
        <h6 v-if="$route.params.template == 0">
          {{ $route.name }} -
          {{ $sessionsStorage.get("booking_resp_frt_enq_id") > 0 ? form.enquiry_no : "" }}
          - Booking NO -{{
            $sessionsStorage.get("booking_resp_frt_enq_id") > 0
              ? form.enquiry_booking_no
              : ""
          }}
        </h6>
        <h6 v-else-if="$route.params.template == 1">Add Booking Response Template</h6>
        <hr />
        <b-card class="formCard">
          <b-card-text>
            <b-col md="12" class="mx-auto text-right">
              <b-button @click="goBack" size="xxl" variant="outline-danger">
                Back
              </b-button>
              <b-button v-if="$route.params.template == 0" @click="saveBookingResp(0)" size="xxl" :disabled="isSubmited"
                variant="outline-success">
                <md-spinner v-if="isSubmited" md-indeterminate style="width: 20px; height: 20px"></md-spinner>
                Save
              </b-button>
              <b-button v-if="$route.params.template == 1" @click="saveBookingResp(1)" size="xxl" :disabled="isSubmited"
                variant="outline-success">
                <md-spinner v-if="isSubmited" md-indeterminate style="width: 20px; height: 20px"></md-spinner>
                Save Template
              </b-button>
            </b-col>
            <!-- Custom Grid Table Layout -->
            <b-row class="table-header">
              <div class="table-responsive tableMain col-md-12">
                <table class="table table-sm table-bordered">
                  <tbody style="background: white">
                    <tr>
                      <th scope="col" style="background-color: yellow">Field</th>
                      <th scope="col" style="background-color: yellow">Value</th>
                    </tr>
                    <tr v-if="$route.params.template == 1">
                      <th scope="col">Template Name.<span class="error">*</span></th>
                      <th scope="col">
                        <b-form-input v-if="$route.params.template == 1" v-model="form.template_name"
                          aria-placeholder="Please Enter Template Name" :style="{
                            borderColor:
                              !form.template_name && errorList.template_name ? 'red' : '',
                          }" />
                        <span class="error" v-if="!form.template_name">
                          {{ errorList.template_name }}
                        </span>
                      </th>
                    </tr>
                    <tr v-if="$route.params.template == 1">
                      <th scope="col">Template Valid Till<span class="error">*</span></th>
                      <th scope="col">
                        <b-form-input v-if="$route.params.template == 1" type="date" v-model="form.template_valid_till"
                          aria-placeholder="Please Enter Template Valid Till" :style="{
                            width: '180px',
                            borderColor:
                              !form.template_valid_till && errorList.template_valid_till
                                ? 'red'
                                : '',
                          }" />
                        <span class="error" v-if="!form.template_valid_till">
                          {{ errorList.template_valid_till }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <!-- <tr v-if="$route.params.type == 0"> -->
                      <th scope="col">Booking Type</th>
                      <th scope="col">
                        <model-list-select :list="BookingTypeList" @input="getClearContractNoErr()"
                          v-model="form.bookingType" option-value="bkgval" option-text="bkgtxt"
                          placeholder="Select Booking Type"></model-list-select>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">Billing Type</th>
                      <th scope="col">
                        <model-list-select :list="BillingTypeList" v-model="form.billing_type" option-value="inv"
                          option-text="int" placeholder="Select Billing Type"></model-list-select>
                      </th>
                    </tr>
 <tr>
                      <th scope="col">INCO TERM SHIPMENT TERM</th>
                      <th scope="col">
                        <!-- :isDisabled="form.prbr_id > 0" -->
                        <model-list-select :list="deliveryTermsList" v-model="form.inco_term" option-value="value"
                          option-text="text" placeholder="Select Incoterm" required :style="{
                            borderColor:
                              !form.inco_term && errorList.inco_term ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.inco_term">
                          {{ errorList.inco_term }}
                        </span>
                      </th>
                    </tr>
                    <tr v-if="$route.params.type == 0">
                      <th scope="col">Line Booking No.<span class="error">*</span></th>
                      <th scope="col">
                        <b-form-input v-if="$route.params.type == 0" v-model="form.booking_no"
                          aria-placeholder="Please Enter Line Booking No" :style="{
                            borderColor:
                              !form.booking_no && errorList.booking_no ? 'red' : '',
                          }" />
                        <span class="error" v-if="!form.booking_no">
                          {{ errorList.booking_no }}
                        </span>
                      </th>
                    </tr>
                    <tr v-if="$route.params.type == 0 || $route.params.type == 1">
                      <th scope="col">Booking For<span class="error">*</span></th>
                      <th scope="col">
                        <model-list-select :list="BookingForList" @input="clearError()" v-model="form.booking_for"
                          option-value="bkgval" option-text="bkgtxt" placeholder="Select Booking For" :style="{
                            borderColor:
                              !form.booking_for && errorList.booking_for ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.booking_for">
                          {{ errorList.booking_for }}
                        </span>
                      </th>
                    </tr>

                    <tr v-if="form.booking_for == 'Agent'">
                      <th scope="col">
                        AGENT<span class="error">{{
                          form.booking_for == "Agent" ? "*" : ""
                        }}</span>
                      </th>
                      <th scope="col">
                        <model-list-select :list="$store.getters['common/getAllAgentColoaderList']"
                          @input="getAgentHandlingExpense(form.fk_agent_id)" option-value="agntColoaderId"
                          option-text="agentName" v-model="form.fk_agent_id" placeholder="Select AGENT" :style="{
                            borderColor:
                              (!form.fk_agent_id && errorList.fk_agent_id && form.booking_for == 'Agent') ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.fk_agent_id && form.booking_for == 'Agent'">
                          {{ errorList.fk_agent_id }}
                        </span>
                      </th>
                    </tr>
                    <tr v-if="form.booking_for == 'Client'">
                      <th scope="col">SHIPPER<span class="error">*</span></th>

                      <th scope="col">
                        <div>
                          <label>
                            <input type="radio" value="existing" v-model="clientType"
                              @input="chnageShipper(clientType)" /> Existing
                            SHIPPER
                          </label>
                          <label>
                            <input type="radio" value="new" v-model="clientType" @input="chnageShipper(clientType)" />
                            New SHIPPER
                          </label>

                        </div>
                        <!-- <model-list-select :list="$store.getters['common/getAllClientList']" id="clientfilter"
                          v-model="form.fk_client_id" option-value="clientId" option-text="clientName"
                          placeholder="Select SHIPPER" required :style="{
                            borderColor:
                              !form.fk_client_id && errorList.fk_client_id ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.fk_client_id && form.booking_for == 'Client'">
                          {{ errorList.fk_client_id }}
                        </span>
                        <div v-if="clientType === 'new'">
                          <b-button variant="primary" style="font-size: 0.675rem" @click="addShipperModal">Add New SHIPPER</b-button>
                        </div> -->
                        <div class="d-flex align-items-center">
                          <model-list-select :list="$store.getters['common/getAllClientList']" id="clientfilter"
                            v-model="form.fk_client_id" option-value="clientId" option-text="clientName"
                            placeholder="Select SHIPPER" required :style="{
                              borderColor: !form.fk_client_id && errorList.fk_client_id ? 'red' : '',
                            }">
                          </model-list-select>

                          <!-- New SHIPPER button to open modal -->
                          <div v-if="clientType === 'new'" class="ml-2">
                            <b-button variant="primary" style="font-size: 0.675rem" @click="addShipperModal">
                              Add New SHIPPER
                            </b-button>
                          </div>
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">
                        EXPENSES HANDLING AGENT<span class="error">{{
                          form.booking_for == "Agent" ? "" : ""
                        }}</span>
                      </th>
                      <th scope="col">
                        <model-list-select @input="getAgentHandlingExpense(form.fk_agent_id)"
                          :isDisabled="form.booking_for == 'Agent' ? true : false"
                          :list="$store.getters['common/getAllAgentColoaderList']" option-value="agntColoaderId"
                          option-text="agentName" v-model="form.fk_agent_id" placeholder="Select AGENT" :style="{
                            borderColor:
                              (!form.fk_agent_id && errorList.fk_agent_id && form.booking_for == 'Agent') ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.fk_agent_id && form.booking_for == 'Agent'">
                          {{ errorList.fk_agent_id }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">
                        AGENT HANDLING EXPENSES to PRIDEL<span class="error">{{
                          form.booking_for == "Agent" ? "" : ""
                        }}</span>
                      </th>
                      <th scope="col">
                        <model-list-select :isDisabled="form.booking_for == 'Agent' ? true : false"
                          :list="agentHandlingExpenseList" option-value="bkgval" option-text="bkgtxt"
                          v-model="form.agent_handling_expense" placeholder="Select AGENT" :style="{
                            borderColor:
                              (!form.agent_handling_expense && errorList.agent_handling_expense && form.fk_agent_id) ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.agent_handling_expense && form.fk_agent_id">
                          {{ errorList.agent_handling_expense }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">Enquiry No.</th>
                      <th scope="col">
                        <b-form-input :disabled="true" v-model="form.enquiry_no" />
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">Shipment Type: <span class="error">*</span></th>
                      <th scope="col">
                        <!-- :isDisabled="form.prbr_id > 0" -->
                        <model-list-select :list="shipment_typeList" id="shipment_type" v-model="form.shipment_type"
                          option-value="value" option-text="text" placeholder="Please Select Shipment Type" :style="{
                            borderColor:
                              !form.shipment_type && errorList.shipment_type ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.shipment_type">
                          {{ errorList.shipment_type }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">Transport Type<span class="error">*</span></th>

                      <!-- :isDisabled="form.prbr_id > 0" -->
                      <th scope="col">
                        <model-list-select :list="moduelTypeList" id="transport_type" v-model="form.transport_type"
                          option-value="value" option-text="text" placeholder="Please Select Transport Type" :style="{
                            borderColor:
                              !form.transport_type && errorList.transport_type
                                ? 'red'
                                : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.transport_type">
                          {{ errorList.transport_type }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">Branch<span class="error">*</span></th>

                      <th scope="col">
                        <model-list-select class="ml-1" :list="$store.getters['common/getAllBranchList']"
                          id="fk_branch_id" v-model="form.fk_branch_id" option-value="pickupId"
                          option-text="pickupLocation" placeholder="Select Branch" :style="{
                            borderColor:
                              !form.fk_branch_id && errorList.fk_branch_id ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.fk_branch_id">
                          {{ errorList.fk_branch_id }}
                        </span>
                      </th>
                    </tr>
                   
                    <!-- <tr>
                      <th scope="col">SHIPPER<span class="error">*</span></th>
                      <th scope="col">
                        
                        <model-list-select
                          :list="$store.getters['common/getAllClientList']"
                          id="clientfilter"
                          v-model="form.fk_client_id"
                          option-value="clientId"
                          option-text="clientName"
                          placeholder="Select SHIPPER"
                          required
                          :style="{
                            borderColor:
                              !form.fk_client_id && errorList.fk_client_id ? 'red' : '',
                          }"
                        ></model-list-select>
                        <span class="error" v-if="!form.fk_client_id">
                          {{ errorList.fk_client_id }}
                        </span>
                      </th>
                    </tr> -->
                    <tr>
                      <th scope="col">
                        FREIGHT TERMS ( MBL)<span class="error"></span>
                      </th>
                      <th scope="col">
                        <model-list-select :list="oceanFreightTermsName" option-value="TermsVal"
                          option-text="TermsText" v-model="form.freight_terms_mbl"
                          placeholder="Select FREIGHT TERMS ( MBL)" :style="{
                            borderColor:
                              !form.freight_terms_mbl && errorList.freight_terms_mbl ? 'red' : '',
                          }" />
                        <span class="error" v-if="!form.freight_terms_mbl">
                          {{ errorList.freight_terms_mbl }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">
                        FREIGHT TERMS ( HBL)<span class="error"></span>
                      </th>
                      <th scope="col">
                        <model-list-select :list="oceanFreightTermsName" option-value="TermsVal"
                          option-text="TermsText" v-model="form.freight_terms_hbl"
                          placeholder="Select FREIGHT TERMS ( HBL)" :style="{
                            borderColor:
                              !form.freight_terms_hbl && errorList.freight_terms_hbl ? 'red' : '',
                          }" />
                        <span class="error" v-if="!form.freight_terms_hbl">
                          {{ errorList.freight_terms_hbl }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">
                        DESTINATION CHARGES<span class="error"></span>
                      </th>
                      <th scope="col">
                        <model-list-select :list="oceanFreightTermsName" option-value="TermsVal"
                          option-text="TermsText" v-model="form.destination_charges"
                          placeholder="Select DESTINATION CHARGES" :style="{
                            borderColor:
                              !form.destination_charges && errorList.destination_charges ? 'red' : '',
                          }" />
                        <span class="error" v-if="!form.destination_charges">
                          {{ errorList.destination_charges }}
                        </span>
                      </th>
                    </tr>
                     <tr>
                      <th scope="col">DESTINATION CHARGES Det.</th>
                      <th scope="col">
                        <b-form-input v-model="form.destination_charges_det" />
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">
                        First Mile Booking<span class="error"></span>
                      </th>
                      <th scope="col">
                        <!-- :isDisabled="form.prbr_id > 0" -->
                        <model-list-select :list="firstMileBookingList" option-value="bkgval"
                          option-text="bkgtxt" v-model="form.first_mile_booking"
                          placeholder="Select First Mile Booking" :style="{
                            borderColor:
                              !form.first_mile_booking && errorList.first_mile_booking ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.first_mile_booking">
                          {{ errorList.first_mile_booking }}
                        </span>
                      </th>
                    </tr>
                      <tr>
                      <th scope="col">
                        Destination Delivery Mode<span class="error">*</span>
                      </th>
                      <th scope="col">
                        <!-- :isDisabled="form.prbr_id > 0" -->
                        <model-list-select :list="deliveryModeName" option-value="deliveryModeVal"
                          option-text="deliveryModeText" v-model="form.delivery_mode"
                          placeholder="Select Destination Delivery Mode" :style="{
                            borderColor:
                              !form.delivery_mode && errorList.delivery_mode ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.delivery_mode">
                          {{ errorList.delivery_mode }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">EMPTY PICK UP<span class="error">*</span></th>
                      <th scope="col">
                        <!-- :isDisabled="
                            form.shipment_type == '' ||
                            form.transport_type == '' ||
                            form.prbr_id > 0
                              ? true
                              : false
                          " -->
                        <model-list-select :list="form.transport_type == 'CRC'
                          ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                          ]
                          : form.transport_type == 'EXPORT'
                            ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
                            ]
                            : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
                            ]
                          " v-model="form.fk_epk_id" option-value="pickupId" option-text="pickupLocation"
                          placeholder="Select POR" :style="{
                            borderColor:
                              !form.fk_epk_id && errorList.fk_epk_id ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.fk_epk_id">
                          {{ errorList.fk_epk_id }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">HANDOVER<span class="error">*</span></th>
                      <th scope="col">
                        <!-- :isDisabled="
                            form.shipment_type == '' ||
                            form.transport_type == '' ||
                            form.fk_por_id ||
                            form.prbr_id > 0
                              ? true
                              : false
                          " -->
                        <model-list-select :list="form.transport_type == 'CRC'
                          ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                          ]
                          : form.transport_type == 'EXPORT'
                            ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
                            ]
                            : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
                            ]
                          " v-model="form.fk_por_id" option-value="pickupId" option-text="pickupLocation"
                          placeholder="Select POR" :style="{
                            borderColor:
                              !form.fk_por_id && errorList.fk_por_id ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.fk_por_id">
                          {{ errorList.fk_por_id }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">POL<span class="error">*</span></th>
                      <th scope="col">
                        <!-- :isDisabled="
                            form.shipment_type == '' ||
                            form.transport_type == '' ||
                            form.fk_pol_id ||
                            form.prbr_id > 0
                              ? true
                              : false
                          " -->
                        <model-list-select :list="form.transport_type == 'CRC'
                          ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                          ]
                          : form.transport_type == 'EXPORT'
                            ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
                            ]
                            : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
                            ]
                          " v-model="form.fk_pol_id" option-value="pickupId" option-text="pickupLocation"
                          placeholder="Select POL" :style="{
                            borderColor:
                              !form.fk_pol_id && errorList.fk_pol_id ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.fk_pol_id">
                          {{ errorList.fk_pol_id }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">POD<span class="error">*</span></th>
                      <th scope="col">
                        <!-- :isDisabled="
                            form.shipment_type == '' ||
                            form.transport_type == '' ||
                            form.fk_pod_id ||
                            form.prbr_id > 0
                              ? true
                              : false
                          " -->
                        <model-list-select :list="form.transport_type == 'CRC'
                          ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                          ]
                          : form.transport_type == 'EXPORT'
                            ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
                            ]
                            : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
                            ]
                          " v-model="form.fk_pod_id" option-value="pickupId" option-text="location"
                          placeholder="Select POD" :style="{
                            borderColor:
                              !form.fk_pod_id && errorList.fk_pod_id ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.fk_pod_id">
                          {{ errorList.fk_pod_id }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                       <!-- v-if="form.delivery_mode == 'CY_StoreDoor' || form.delivery_mode == 'CY_RAMP'" -->
                      <th scope="col">FINAL DESTINATION<span class="error">*</span></th>
                      <th scope="col">
                        <!-- :isDisabled="
                            form.shipment_type == '' ||
                            form.transport_type == '' ||
                            form.fk_fpod_id ||
                            form.prbr_id > 0
                              ? true
                              : false
                          " -->
                        <model-list-select :list="form.transport_type == 'CRC'
                          ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                          ]
                          : form.transport_type == 'EXPORT'
                            ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
                            ]
                            : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPFPODDDList'
                            ]
                          " v-model="form.fk_fpod_id" option-value="pickupId" option-text="location"
                          placeholder="Select FPOD" :style="{
                            borderColor:
                              !form.fk_fpod_id && errorList.fk_fpod_id ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.fk_fpod_id">
                          {{ errorList.fk_fpod_id }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">RA NUMBER <span class="error" v-if="form.bookingType == 'ON CONTRACT'">*</span>
                        &nbsp;&nbsp;&nbsp;
                        <b-button variant="primary" @click="openContractModal()" id="addButtonLoader" size="sm"
                          style="margin-top: 2px">Add</b-button>
                      </th>
                      <th scope="col">
                        <!-- :disabled="form.prbr_id > 0" -->
                        <model-list-select class="ml-1" :list="$store.getters['common/getAllContractList']"
                          id="fk_contract_id" v-model="form.fk_contract_id" option-value="value" option-text="label"
                          placeholder="Select RA NUMBER" @input="getContractNo(form.fk_contract_id)" :style="{
                            borderColor:
                              !form.fk_contract_id && errorList.fk_contract_id
                                ? 'red'
                                : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.fk_contract_id && errorList.fk_contract_id">
                          {{ errorList.fk_contract_id }}
                        </span>
                        <!-- {{ errorList }} -->
                        <b-form-input :disabled="true" type="text" v-model="form.ra_number" :style="{
                          borderColor:
                            !form.ra_number && errorList.ra_number ? 'red' : '',
                        }" />
                        <span class="error" v-if="!form.ra_number">
                          {{ errorList.ra_number }}
                        </span>

                      </th>
                    </tr>
                    <tr>
                      <!-- v-if="form.ra_number" -->
                      <!-- v-if="form.bookingType == 'ON CONTRACT'" -->
                      <th scope="col">Vessel Name <span class="error">*</span>
                        <b-button variant="primary" @click="openVesselModal()" id="addButtonLoader" size="sm" style="margin-top: 2px">Add</b-button>
                      </th>
                      <th scope="col">
                        <!-- <div style="display: flex; gap: 5px;">
                          <div style="display: flex; flex-direction: column; width: 50%;">
                            <b-form-input type="text" v-model="form.vessel_name" placeholder="Please Enter Vessel Name"
                              :disabled="form.vessel_name ? true : false"
                              :style="{
                                borderColor:
                                  !form.vessel_name && errorList.vessel_name ? 'red' : '',
                              }" />
                            <span class="error" v-if="!form.vessel_name">
                              {{ errorList.vessel_name }}
                            </span>
                          </div>
                          <div style="display: flex; flex-direction: column; width: 50%;">
                            <b-form-input type="text" v-model="form.vessel_voyage_no"
                            :disabled="form.vessel_name ? true : false"
                              placeholder="Please Enter Voyage No" :style="{
                                borderColor:
                                  !form.vessel_voyage_no && errorList.vessel_voyage_no ? 'red' : '',
                              }" />
                            <span class="error" v-if="!form.vessel_voyage_no">
                              {{ errorList.vessel_voyage_no }}
                            </span>
                          </div>
                        </div> -->
                        <!-- <multi-select :options="$store.getters['common/getAllContractBasedVesselList']"
                          :selected-options="vessel_nameItems" v-model="form.vessel_name"
                          placeholder="Select Vessel Name" :multiple="true" :style="{borderColor:
                              !form.vessel_name && errorList.vessel_name ? 'red' : '',
                          }" @select="SelectMultiVesselName" /> -->
                        <model-list-select class="ml-1" :list="$store.getters['common/getAllContractBasedVesselList']"
                          id="vessel_name" v-model="form.fk_ccbm_id" option-value="value" option-text="label"
                          placeholder="Select Vessel Name" @input="getAllContractBasedVesselList(form.fk_ccbm_id)" :style="{
                            borderColor:
                              !form.vessel_name && errorList.fk_ccbm_id
                                ? 'red'
                                : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.fk_ccbm_id && errorList.fk_ccbm_id">
                          {{ errorList.fk_ccbm_id }}
                        </span>
                      </th>
                    </tr>
                    <!-- <tr>
                      <th scope="col">EQUIPMENT<span class="error">*</span></th>
                      <th scope="col">
                        <model-list-select
                          :list="$store.getters['common/getAllContainerTypeList']"
                          v-model="form.fk_container_id"
                          option-value="containerTypeId"
                          option-text="containerType"
                          placeholder="Select Container Type"
                          :style="{
                            borderColor:
                              !form.fk_container_id && errorList.fk_container_id
                                ? 'red'
                                : '',
                          }"
                        ></model-list-select>
                        <span class="error" v-if="!form.fk_container_id">
                          {{ errorList.fk_container_id }}
                        </span>
                      </th>
                    </tr> -->
                    <tr>
                      <th scope="col" colspan="2">
                        <table class="table table-sm table-bordered mt-2">
                          <tbody style="background: white">
                            <tr v-if="CONTAINERCOUNTArr.length > 0">
                              <th scope="col" style="width: 5px">SN.</th>
                              <th scope="col" style="width: 200px">
                                CONTAINER TYPE<span class="error">*</span>
                              </th>
                              <th scope="col" style="width: 180px">
                                CONTAINER COUNT<span class="error">*</span>
                              </th>
                              <th scope="col" style="width: 180px">
                                CURRENCY<span class="error">*</span>
                              </th>
                              <th scope="col" style="width: 180px">
                                Buying Rate<span class="error">*</span>
                              </th>
                              <th scope="col" style="width: 180px">
                                Selling Rate<span class="error">*</span>
                              </th>
                              <th scope="col" style="width: 180px">Remark</th>
                              <th scope="col" style="width: 5px">
                                Actions
                                <!-- v-if="form.vessel_name.length <= 0 && form.bookingType != 'ON CONTRACT'" -->
                                <b-button @click="addContainerCount()" size="sm"
                                 >
                                  <i class="fa fa-plus-circle ml-1"></i>
                                </b-button>
                              </th>
                            </tr>

                            <tr v-for="(item, index) in CONTAINERCOUNTArr" :key="index">
                              <th scope="row">{{ index + 1 }}.</th>
                              <td>
                                <!-- :isDisabled="form.vessel_name ? true : false" -->
                                 
                                <!-- :isDisabled="form.vessel_name.length > 0 ? true : false" -->
                                <model-list-select :list="$store.getters['common/getAllContainerTypeList']"
                                  v-model="item.fk_cont_type_id" option-value="containerTypeId"
                                  option-text="containerType" placeholder="Select Container Type" :style="{
                                    borderColor:
                                      !item.fk_cont_type_id && errorList.fk_cont_type_id
                                        ? 'red'
                                        : '',
                                  }"></model-list-select>
                                <span class="error" v-if="item.fk_cont_type_id_err ? true : false">{{
                                  item.fk_cont_type_id_err }}</span>
                              </td>
                              <td>
                                <b-form-input :formatter="capitalizeAll" v-model="item.brcm_tot_continer" type="number"
                                  placeholder="Enter Container Count"></b-form-input>
                                <span class="error" v-if="item.brcm_tot_continer_err ? true : false">{{
                                  item.brcm_tot_continer_err }}</span>
                              </td>
                              <td>
                                <!-- :isDisabled="form.vessel_name ? true : false" -->
                                <!-- :isDisabled="form.vessel_name.length > 0 ? true : false" -->
                                <model-list-select 
                                  :list="$store.getters['common/getAllCurrencyList']" v-model="item.fk_currency_id"
                                  option-value="currency_id" option-text="currencyCode"
                                  placeholder="Select Currency"></model-list-select>
                                <span class="error" v-if="item.fk_currency_id_err ? true : false">{{
                                  item.fk_currency_id_err }}</span>
                              </td>
                              <td>
                                <!-- :disabled="form.vessel_name ? true : false" -->
                                 
                                <!-- :disabled="form.vessel_name.length > 0 ? true : false" -->
                                <b-form-input :formatter="capitalizeAll" v-model="item.brcm_rate" type="number"
                                  placeholder="Enter Buying Rate"></b-form-input>
                                <span class="error" v-if="item.brcm_rate_err ? true : false">{{ item.brcm_rate_err
                                }}</span>
                              </td>
                              <td>
                                <b-form-input :formatter="capitalizeAll" v-model="item.brcm_sell_rate" type="number"
                                  placeholder="Enter Selling Rate"></b-form-input>
                                <span class="error" v-if="item.brcm_sell_rate_err ? true : false">{{
                                  item.brcm_sell_rate_err
                                }}</span>
                              </td>
                              <td>
                                <b-textarea :formatter="capitalizeAll" v-model="item.brcm_continer_remark" row="2"
                                  placeholder="Enter Remark"></b-textarea>
                                <span class="error" v-if="item.brcm_continer_remark_err ? true : false">{{
                                  item.brcm_continer_remark_err }}</span>
                              </td>
                              <td>
                                <b-button v-if="index > 0" size="sm" @click="removeContainerCount(index)">
                                  <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                </b-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">Commodity Type<span class="error">*</span></th>
                      <th scope="col">
                        <!-- :isDisabled="form.prbr_id > 0" -->
                        <model-list-select :list="commodityTypeList" v-model="form.commodity_type" option-value="value"
                          option-text="text" placeholder="Select Commodity Type" :style="{
                            borderColor:
                              !form.commodity_type && errorList.commodity_type
                                ? 'red'
                                : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.commodity_type">
                          {{ errorList.commodity_type }}
                        </span>
                      </th>
                    </tr>
                    <tr v-if="form.commodity_type == 'Hazardous'">
                      <th scope="col">IMDG Class</th>
                      <th scope="col">
                        <!-- :disabled="form.prbr_id > 0" -->
                        <b-form-input :formatter="capitalizeAll" id="imdg_class" name="imdg_class"
                          v-model="form.imdg_class" :style="{
                            borderColor:
                              !form.imdg_class && errorList.imdg_class ? 'red' : '',
                          }"></b-form-input>
                        <span class="error" v-if="!form.imdg_class">
                          {{ errorList.imdg_class }}
                        </span>
                      </th>
                    </tr>
                    <tr v-if="form.commodity_type == 'Hazardous'">
                      <th scope="col">UN Number</th>
                      <th scope="col">
                        <!-- :disabled="form.prbr_id > 0" -->
                        <b-form-input :formatter="capitalizeAll" id="un_number" name="un_number"
                          v-model="form.un_number" :style="{
                            borderColor:
                              !form.un_number && errorList.un_number ? 'red' : '',
                          }"></b-form-input>
                        <span class="error" v-if="!form.un_number">
                          {{ errorList.un_number }}
                        </span>
                      </th>
                    </tr>
                    <tr v-if="form.commodity_type == 'Hazardous'">
                      <th scope="col">Packing Code</th>
                      <th scope="col">
                        <!-- :disabled="form.prbr_id > 0" -->
                        <b-form-input :formatter="capitalizeAll" id="packing_code" name="packing_code"
                          v-model="form.packing_code" :style="{
                            borderColor:
                              !form.packing_code && errorList.packing_code ? 'red' : '',
                          }"></b-form-input>
                        <span class="error" v-if="!form.packing_code">
                          {{ errorList.packing_code }}
                        </span>
                      </th>
                    </tr>
                    <tr v-if="form.commodity_type == 'Reefer'">
                      <th scope="col">Temperature Req(Degree Celsius)</th>
                      <th scope="col">
                        <!-- :disabled="form.prbr_id > 0" -->
                        <b-form-input :formatter="capitalizeAll" id="temperature_required" name="temperature_required"
                          :min="0" :max="100" type="number" v-model="form.temperature_required" :style="{
                            borderColor:
                              (!form.temperature_required &&
                                errorList.temperature_required) ||
                                form.temperature_required > 100
                                ? 'red'
                                : '',
                          }" @keyup="validateDegree('temperature_required')"></b-form-input>
                        <span class="error" v-if="form.temperature_required > 100">Temperature Req(Degree Celsius) Must
                          Be Less Than Equal To
                          100</span>
                        <span class="error" v-if="!form.temperature_required">
                          {{ errorList.temperature_required }}
                        </span>
                      </th>
                    </tr>
                    <tr v-if="form.commodity_type == 'Others'">
                      <th scope="col">Specific Detail if any..!</th>
                      <th scope="col">
                        <!-- :disabled="form.prbr_id > 0" -->
                        <b-form-input :formatter="capitalizeAll" id="other_comodity" name="other_comodity"
                          v-model="form.other_comodity" :style="{
                            borderColor:
                              !form.other_comodity && errorList.other_comodity
                                ? 'red'
                                : '',
                          }"></b-form-input>
                        <span class="error" v-if="!form.other_comodity">
                          {{ errorList.other_comodity }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">COMMODITY & HS CODE<span class="error">*</span></th>
                      <th scope="col">
                        <!-- :isDisabled="form.prbr_id > 0" -->
                        <model-list-select @searchchange="getCommodityList($event, 'getCommodityData')"
                          :list="commodityList" v-model="form.fk_commodity_id" option-value="commodityId"
                          option-text="itemHSNCode" placeholder="Select Commodity" :style="{
                            borderColor:
                              !form.fk_commodity_id && errorList.fk_commodity_id
                                ? 'red'
                                : '',
                          }" />
                        <span class="error" v-if="!form.fk_commodity_id">
                          {{ errorList.fk_commodity_id }} </span><b-button variant="primary"
                          @click="openCommodityModal()" id="addButtonLoader" size="sm"
                          style="margin-top: 2px">Add</b-button>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">HUMIDITY (for reefer)</th>
                      <th scope="col">
                        <!-- :disabled="form.prbr_id > 0" -->
                        <b-form-input v-model="form.humidity" required :min="0" :max="100" type="number" :style="{
                          borderColor:
                            (!form.humidity && errorList.humidity) ||
                              form.humidity > 100
                              ? 'red'
                              : '',
                        }" @keyup="validateDegree('humidity')" />
                        <span class="error" v-if="form.humidity > 100">HUMIDITY Must Be Less Than Equal To 100</span>
                        <span class="error" v-if="!form.humidity">
                          {{ errorList.humidity }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">CARGO WEIGHT</th>
                      <th scope="col">
                        <!-- :disabled="form.prbr_id > 0" -->
                        <b-form-input v-model="form.cargo_weight" :style="{
                          borderColor:
                            !form.cargo_weight && errorList.cargo_weight ? 'red' : '',
                        }" />
                        <span class="error" v-if="!form.cargo_weight">
                          {{ errorList.cargo_weight }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">SHIPPING LINE<span class="error">*</span></th>
                      <th scope="col">
                        <!-- :isDisabled="form.prbr_id > 0" -->
                        <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                          v-model="form.fk_shipping_id" option-value="shippingId" option-text="shippingLine"
                          placeholder="Select Shipping Line" :style="{
                            borderColor:
                              !form.fk_shipping_id && errorList.fk_shipping_id
                                ? 'red'
                                : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.fk_shipping_id">
                          {{ errorList.fk_shipping_id }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">SPOT NON SPOT</th>
                      <th scope="col">
                        <!-- :isDisabled="form.prbr_id > 0" -->
                        <model-list-select :list="spotList" option-value="value" option-text="text"
                          v-model="form.spot_non_spot" placeholder="Select Spot Non-Spot" :style="{
                            borderColor:
                              !form.spot_non_spot && errorList.spot_non_spot ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.spot_non_spot">
                          {{ errorList.spot_non_spot }}
                        </span>
                      </th>
                    </tr>


                    <!-- <tr>
                      <th scope="col">RATE AGREED<span class="error">*</span></th>
                      <th scope="col">
                        <b-form-input
                          type="number"
                          v-model="form.rate_agreed"
                          :style="{
                            borderColor:
                              !form.rate_agreed && errorList.rate_agreed ? 'red' : '',
                          }"
                          @keyup="validateRateAgreed"
                        />
                        <span class="error" v-if="!form.rate_agreed">
                          {{ errorList.rate_agreed }}
                        </span>
                      </th>
                    </tr> -->
                    <tr>
                      <th scope="col">Currency</th>
                      <th scope="col">
                        <!-- :isDisabled="form.prbr_id > 0" -->
                        <model-list-select :list="$store.getters['common/getAllCurrencyList']"
                          v-model="form.fk_currency_id" option-value="currency_id" option-text="currencyCode"
                          placeholder="Select Currency" :style="{
                            borderColor:
                              !form.fk_currency_id && errorList.fk_currency_id
                                ? 'red'
                                : '',
                          }" @input="getCurrencyName(form.fk_currency_id)"></model-list-select>

                        <span class="error" v-if="!form.fk_currency_id">
                          {{ errorList.fk_currency_id }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">FREE DAYS At POD<span class="error">*</span></th>
                      <th scope="col">
                        <!-- :disabled="form.prbr_id > 0" -->
                        <b-form-input type="text" v-model="form.free_days" :style="{
                          borderColor:
                            !form.free_days && errorList.free_days ? 'red' : '',
                        }" />
                        <span class="error" v-if="!form.free_days">
                          {{ errorList.free_days }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">PDA<span class="error">*</span></th>
                      <th scope="col">
                        <!-- :isDisabled="form.prbr_id > 0" -->
                        <model-list-select :list="pdaList" option-value="value" option-text="text" v-model="form.pda"
                          placeholder="Select PDA" :style="{
                            borderColor: !form.pda && errorList.pda ? 'red' : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.pda">
                          {{ errorList.pda }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">SI CUT OFF<span class="error"></span></th>
                      <th scope="col">
                        <!-- :disabled="form.prbr_id > 0" -->
                        <b-form-input
                        :disabled="form.fk_ccbm_id?true:false"
                        type="date" v-model="form.si_cut_of_date" :style="{
                          width: '180px',
                          borderColor: !form.si_cut_of_date && errorList.si_cut_of_date ? 'red' : '',
                        }" />
                        <span class="error" v-if="!form.si_cut_of_date">
                          {{ errorList.si_cut_of_date }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">ETD/SOB<span class="error">*</span></th>
                      <th scope="col">
                        <!-- :disabled="form.prbr_id > 0" -->
                        <b-form-input
                        :disabled="form.fk_ccbm_id?true:false"
                        type="date" v-model="form.etd" :style="{
                          width: '180px',
                          borderColor: !form.etd && errorList.etd ? 'red' : '',
                        }" />
                        <span class="error" v-if="!form.etd">
                          {{ errorList.etd }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">Valid Till<span class="error">*</span></th>
                      <th scope="col">
                        <!-- :disabled="form.prbr_id > 0" -->
                        <b-form-input type="date" v-model="form.valid_till" :style="{
                          width: '180px',
                          borderColor:
                            !form.valid_till && errorList.valid_till ? 'red' : '',
                        }" />
                        <span class="error" v-if="!form.valid_till">
                          {{ errorList.valid_till }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">
                        Quotation Validity Till<span class="error">*</span>
                      </th>
                      <th scope="col">
                        <!-- :disabled="form.prbr_id > 0" -->
                        <model-list-select :list="qTillList" v-model="form.quotation_till" option-value="qV"
                          option-text="qT" placeholder="Select Quotation Validity Till" :style="{
                            borderColor:
                              !form.quotation_till && errorList.quotation_till
                                ? 'red'
                                : '',
                          }"></model-list-select>

                        <span class="error" v-if="!form.quotation_till">
                          {{ errorList.quotation_till }}
                        </span>
                      </th>
                    </tr>
                    <!-- <tr>
                      <th scope="col">Valid For Saling<span class="error">*</span></th>
                      <th scope="col">
                        <b-form-input
                          type="date"
                          v-model="form.valid_for_sail"
                          :style="{
                            width: '180px',
                            borderColor:
                              !form.valid_for_sail && errorList.valid_for_sail
                                ? 'red'
                                : '',
                          }"
                        />
                        <span class="error" v-if="!form.valid_for_sail">
                          {{ errorList.valid_for_sail }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">Handover Date<span class="error">*</span></th>
                      <th scope="col">
                        <b-form-input
                          type="date"
                          v-model="form.handover_date"
                          :style="{
                            width: '180px',
                            borderColor:
                              !form.handover_date && errorList.handover_date ? 'red' : '',
                          }"
                        />
                        <span class="error" v-if="!form.handover_date">
                          {{ errorList.handover_date }}
                        </span>
                      </th>
                    </tr> -->
                  
                    <tr>
                      <th scope="col">BL INSTRUCTION</th>
                      <th scope="col">
                        <!-- :isDisabled="form.prbr_id > 0" -->
                        <model-list-select :list="blINSTRUCTIONList" option-value="value" option-text="text"
                          v-model="form.bl_instruction" placeholder="Select BL INSTRUCTION" :style="{
                            borderColor:
                              !form.bl_instruction && errorList.bl_instruction
                                ? 'red'
                                : '',
                          }"></model-list-select>
                        <span class="error" v-if="!form.bl_instruction">
                          {{ errorList.bl_instruction }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">
                        CS Team/Sales Person<span class="error">*</span>
                      </th>
                      <th scope="col">
                        <model-list-select :list="$store.getters['common/getAllUserList']" id="fk_sales_person_id"
                          v-model="form.fk_sales_person_id" option-value="userId" option-text="employeeName"
                          placeholder="Select Sales Person"></model-list-select>
                        <span class="error" v-if="!form.fk_sales_person_id">
                          {{ errorList.fk_sales_person_id }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">REMARKS (if any)</th>
                      <!-- :disabled="form.prbr_id > 0" -->
                      <th scope="col">
                        <b-form-textarea v-model="form.remarks" />
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
              <b-col md="12" class="mx-auto text-center">
                <b-button @click="goBack" size="xxl" variant="outline-danger">
                  Back
                </b-button>
                <b-button v-if="$route.params.template == 0" @click="saveBookingResp(0)" size="xxl"
                  :disabled="isSubmited" variant="outline-success">
                  <md-spinner v-if="isSubmited" md-indeterminate style="width: 20px; height: 20px"></md-spinner>
                  Save
                </b-button>
                <b-button v-if="$route.params.template == 1" @click="saveBookingResp(1)" size="xxl"
                  :disabled="isSubmited" variant="outline-success">
                  <md-spinner v-if="isSubmited" md-indeterminate style="width: 20px; height: 20px"></md-spinner>
                  Save Template
                </b-button>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
        <!-- Add more rows as needed -->

        <!-- Commodity Modal Added By Priyanshu Singh Start -->
        <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="Commodity-modal" hide-footer title="Add Commodity">
          <b-row class="justify-content-center">
            <b-col md="4">
              <label>Item Name <span class="error">*</span></label>
              <b-form-input size="sm" :formatter="capitalizeAll" id="itemName" name="itemName"
                v-model="commodityModal.itemName" :style="{
                  borderColor:
                    !commodityModal.itemName && errorComodityList.itemName ? 'red' : '',
                }"></b-form-input>
              <span class="error" v-if="!commodityModal.itemName">{{
                errorComodityList.itemName
              }}</span>
            </b-col>
            <b-col md="4">
              <label>HSN Code <span class="error">*</span></label>
              <b-form-input size="sm" :formatter="capitalizeAll" id="hsnCode" name="hsnCode"
                v-model="commodityModal.hsnCode" :style="{
                  borderColor:
                    !commodityModal.hsnCode && errorComodityList.hsnCode ? 'red' : '',
                }"></b-form-input>
              <span class="error" v-if="!commodityModal.hsnCode">{{
                errorComodityList.hsnCode
              }}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="my-3 text-center">
              <b-button :disabled="commodityDisabled" variant="outline-primary" @click="addCommodity"
                id="addButtonLoader" size="sm">Save</b-button>
              <b-button variant="outline-danger" class="ml-2" size="sm" @click="hideCommodityModal">Close</b-button>
            </b-col>
          </b-row>
        </b-modal>
        <!-- Commodity Modal Added By Priyanshu Singh Start -->

        <!-- Vessel Modal Added By Priyanshu Singh Start -->
        <!-- :modal-ref="'vesselModalRef'" -->
        <!-- :modalRef="'vesselModalRef'" -->
        <!-- <DynamicModal ref="vesselModalRef" modal-title="Add Vessel/Voyage" :fields="dynamicVesselFields"
          v-model="vesselModal" :modalSize="'xl'" :modalExtraClass="'w-90'" @save="addVesselVoyage" /> -->


        <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="vesselModalRef" hide-footer
          :title="'Add Vessel/Voyage-' + form.ra_number">
          <b-row>
            <b-col md="6">
              <label>Vessel Name <span class="error">*</span></label>
              <b-form-input size="sm" :formatter="capitalizeAll" id="vessel_name" name="vessel_name"
                v-model="vesselModal.vessel_name" :style="{
                  borderColor:
                    !vesselModal.vessel_name && errorVesselList.vessel_name
                      ? 'red'
                      : '',
                }"></b-form-input>
              <span class="error" v-if="!vesselModal.vessel_name">{{
                errorVesselList.vessel_name
              }}</span>
            </b-col>

            <b-col md="6">
              <label>Voyage No <span class="error">*</span></label>
              <b-form-input size="sm" :formatter="capitalizeAll" id="vessel_voyage_no" name="vessel_voyage_no"
                v-model="vesselModal.vessel_voyage_no" :style="{
                  borderColor:
                    !vesselModal.vessel_voyage_no && errorVesselList.vessel_voyage_no
                      ? 'red'
                      : '',
                }"></b-form-input>
              <span class="error" v-if="!vesselModal.vessel_voyage_no">{{
                errorVesselList.vessel_voyage_no
              }}</span>
            </b-col>

            <b-col md="6">
              <label>SOB <span class="error">*</span></label>
              <b-form-input type="date" v-model="vesselModal.vessel_sail_date" :style="{
                borderColor:
                  !vesselModal.vessel_sail_date && errorVesselList.vessel_sail_date ? 'red' : '',
              }" />
              <span class="error" v-if="!vesselModal.vessel_sail_date">{{
                errorVesselList.vessel_sail_date
              }}</span>
            </b-col>

          </b-row>
          <b-row>
            <b-col class="my-3 text-center">
              <b-button :disabled="contractDisabled" variant="outline-primary" @click="addVesselVoyage"
                id="addButtonLoader" size="sm">Save</b-button>
              <b-button variant="outline-danger" class="ml-2" size="sm" @click="hideVesselModal">Close</b-button>
            </b-col>
          </b-row>
        </b-modal>

        <b-modal no-close-on-esc no-close-on-backdrop class="w-90" size="xl" ref="Contract-modal" hide-footer
          title="Add Contract">
          <b-row>
            <b-col md="12">
              <label>Contract No <span class="error">*</span></label>
              <b-form-input :disabled="contractModal.cb_id > 0 ? true : false" size="sm" :formatter="capitalizeAll"
                id="cb_contarct_no" name="cb_contarct_no" v-model="contractModal.cb_contarct_no" :style="{
                  borderColor:
                    !contractModal.cb_contarct_no && errorContractList.cb_contarct_no
                      ? 'red'
                      : '',
                }"></b-form-input>
              <span class="error" v-if="!contractModal.cb_contarct_no">{{
                errorContractList.cb_contarct_no
              }}</span>
            </b-col>
            <!-- <b-col cols="12">
              <table class="table table-sm table-bordered mt-2">
                <tbody style="background: white">
                  <tr>
                    <th scope="col" style="width: 5px">SN.</th>
                    <th scope="col" style="width: 200px">Container Type</th>
                    <th scope="col" style="width: 200px">Currency</th>
                    <th scope="col" style="width: 180px">Premium Buying Rate</th>
                    <th scope="col" style="width: 180px">Vessel Sail Date</th>
                    <th scope="col" style="width: 180px">Start Date</th>
                    <th scope="col" style="width: 180px">End Date</th>
                    <th scope="col" style="width: 180px">Vessel</th>
                    <th scope="col" style="width: 180px">Remark</th>
                    <th scope="col" style="width: 5px">
                      Actions
                      <b-button :disabled="!contractModal.cb_contarct_no" @click="addContractContainerRate(null)"
                        size="sm">
                        <i class="fa fa-plus-circle ml-1"></i>
                      </b-button>
                    </th>
                  </tr>
                  <tr v-for="(item, index) in contractContainerArr" :key="index">
                    <th scope="row">{{ index + 1 }}.</th>
                    <td>
                      <model-list-select :isDisabled="item.ccbm_id > 0 ? true : false"
                        :list="$store.getters['common/getAllContainerTypeList']" v-model="item.fk_cont_type_id"
                        option-value="containerTypeId" option-text="containerType"
                        placeholder="Select Container Type"></model-list-select>
                      <span class="error" v-if="item.fk_cont_type_id_err ? true : false">{{
                        item.fk_cont_type_id_err
                      }}</span>
                    </td>
                    <td>
                      <model-list-select :isDisabled="item.ccbm_id > 0 ? true : false"
                        :list="$store.getters['common/getAllCurrencyList']" v-model="item.fk_currency_id"
                        option-value="currency_id" option-text="currencyCode"
                        placeholder="Select Currency"></model-list-select>
                      <span class="error" v-if="item.fk_currency_id_err ? true : false">{{
                        item.fk_currency_id_err
                      }}</span>
                    </td>
                    <td>
                      <b-form-input :disabled="item.ccbm_id > 0 ? true : false" style="width: 90%"
                        :formatter="capitalizeAll" v-model="item.continer_premium_contract_rate" type="number"
                        placeholder="Premium Buying Rate" />
                      <span class="error" v-if="item.continer_premium_contract_rate_err ? true : false">{{
                        item.continer_premium_contract_rate_err }}</span>
                    </td>
                    <td>
                      <date-picker :disabled="item.ccbm_id > 0 ? true : false" style="width: 90%"
                        :format="selectDateFormat" lang="en" :minute-step="1" name="vessel_sail_date"
                        id="vessel_sail_date" v-model="item.vessel_sail_date" placeholder="Enter Vessel Sail Date" />
                      <span class="error" v-if="item.vessel_sail_date_err ? true : false">{{
                        item.vessel_sail_date_err }}</span>
                    </td>
                    <td>
                      <date-picker :disabled="item.ccbm_id > 0 ? true : false" style="width: 90%"
                        :format="selectDateFormat" lang="en" :minute-step="1" name="start_date" id="start_date"
                        v-model="item.start_date" placeholder="Enter Start Date" />
                      <span class="error" v-if="item.start_date_err ? true : false">{{
                        item.start_date_err }}</span>
                    </td>
                    <td>
                      <date-picker :disabled="item.ccbm_id > 0 ? true : false" style="width: 90%"
                        :format="selectDateFormat" lang="en" :minute-step="1" name="end_date" id="end_date"
                        v-model="item.end_date" placeholder="Enter End Date" />
                      <span class="error" v-if="item.end_date_err ? true : false">{{
                        item.end_date_err }}</span>
                    </td>
                    <td>
                      <b-form-input :disabled="item.ccbm_id > 0 ? true : false" :formatter="capitalizeAll"
                        v-model="item.vessel_name" type="text" placeholder="Vessel Name" />
                      <span class="error" v-if="item.vessel_name_err ? true : false">{{
                        item.vessel_name_err }}</span>

                      <b-form-input :disabled="item.ccbm_id > 0 ? true : false" class="mt-2" :formatter="capitalizeAll"
                        v-model="item.vessel_voyage_no" type="text" placeholder="Voyage No" />
                      <span class="error" v-if="item.vessel_voyage_no_err ? true : false">{{
                        item.vessel_voyage_no_err }}</span>
                    </td>
                    <td>
                      <b-textarea :disabled="item.ccbm_id > 0 ? true : false" rows="2" :formatter="capitalizeAll"
                        v-model="item.continer_remark" type="text" placeholder="Enter Remark"></b-textarea>
                    </td>
                    <td>
                      <b-button :disabled="item.ccbm_id > 0 ? true : false" v-if="index > 0" size="sm"
                        @click="removeContractContainerRate(index)">
                        <i class="fa fa-minus-circle" aria-hidden="true"></i>
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col class="my-3 text-center">
              <b-button :disabled="contractDisabled" variant="outline-primary" @click="addContract" id="addButtonLoader"
                size="sm">Save</b-button>
              <b-button variant="outline-danger" class="ml-2" size="sm" @click="hideContractModal">Close</b-button>
            </b-col>
          </b-row>
        </b-modal>
        <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
        <!-- Contract Modal Added By Priyanshu Singh Start -->


        <!-- New Shipper Modal Added By Priyanshu Singh Start -->
        <b-modal ref="ShipperModal" no-close-on-esc no-close-on-backdrop title="Add New Shipper" size="lg" hide-footer
          @hidden="closeShipperModal">
          <b-row class="mb-2">
            <b-col cols="4">
              <label for="client-name">Client Name<span class="error">*</span></label>
              <b-form-input id="client-name" v-model="newShipperForm.clientName" placeholder="Enter Client Name" />
              <span class="error" v-if="validationNewShipperErrors.clientName">
                {{ validationNewShipperErrors.clientName }}
              </span>
            </b-col>
            <b-col cols="4">
              <label for="client-email">Email</label>
              <b-form-input id="client-email" type="email" @keyup="isValidEmail(newShipperForm.email)"
                v-model="newShipperForm.email" placeholder="Enter Email" />
              <span class="error" v-if="validationNewShipperErrors.email">
                {{ validationNewShipperErrors.email }}
              </span>
            </b-col>
            <b-col cols="4">
              <label for="client-pan">PAN(AAAAA1234A)<span class="error">*</span></label>
              <b-form-input id="client-pan" v-model="newShipperForm.pan" @keyup="isValidPAN(newShipperForm.pan)"
                placeholder="Enter PAN Number" />
              <span class="error" v-if="validationNewShipperErrors.pan">
                {{ validationNewShipperErrors.pan }}
              </span>
            </b-col>
            <b-col cols="4">
              <label for="client-gst">GST(09AAAAA1234A1Z5)<span class="error">*</span></label>
              <b-form-input id="client-gst" v-model="newShipperForm.gst" @keyup="isValidGST(newShipperForm.gst)"
                placeholder="Enter GST Number" />
              <span class="error" v-if="validationNewShipperErrors.gst">
                {{ validationNewShipperErrors.gst }}
              </span>
            </b-col>
            <b-col cols="8">
              <label for="client-address">Address</label>
              <b-form-textarea id="client-address" v-model="newShipperForm.address" placeholder="Enter Address"
                rows="2" />
              <span class="error" v-if="validationNewShipperErrors.address">
                {{ validationNewShipperErrors.address }}
              </span>
            </b-col>
          </b-row>
          <b-row class="justify-content-end">
            <b-button variant="primary" style="font-size: 0.675rem" @click="saveShipper">Update</b-button>
            <b-button variant="secondary" style="font-size: 0.675rem" @click="closeShipperModal"
              class="ml-2">Cancel</b-button>
          </b-row>
        </b-modal>
        <!-- New Shipper Modal Added By Priyanshu Singh End -->
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import CustomLoader from "../common/customLoader.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import Multiselect from "vue-multiselect";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import MasterService from "../../services/MasterService.js";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
import { lastVisitPage, GlobalGetCommodity2 } from "../../helper/collection";
import LeadService from "../../services/LeadService.js";
import DatePicker from "vue2-datepicker";
import DynamicModal from "../common/DynamicModal.vue";
export default {
  beforeMount() {
    this.getEnquiryPrcingList();
    // Define the store actions as promises
    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),
      this.$store.dispatch("common/setAllAgentColoaderList"),
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      ),
      this.$store.dispatch("common/setAllContractList", {
        filter: "ContractList",
        active: "all",
        isAll: 1,
        cb_is_active: 1,
        cb_is_deleted: 0,
        isSelectedColumn: 1,
      }),
      // this.$store.dispatch("common/setAllContractBasedVesselList", {
      //   filter: "ContractVesselList",
      //   active: "all",
      //   isAll: 0,
      //   ccbm_is_active: 1,
      //   ccbm_is_deleted: 0,
      //   isSelectedColumn: 1,
      //   fk_cb_id: 0,
      //   is_withoutcb: 0,
      // }),
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList", isKYC: "Yes", isBRF: 0 })
      ),
      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({ itemCode: "ContainerTypeList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEnginePODDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEnginePODDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineFPODDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEngineFPODDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEnginePOLDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEnginePOLDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEnginePORDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEnginePORDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineCrossCountryLocationDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEngineCrossCountryDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPODDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEngineIMPPODDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPOLDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEngineIMPPOLDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPFPODDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEngineIMPFPODDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPORDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEngineIMPPORDDList" })
      ),
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),
      this.$store.dispatch("common/setAllContractBasedVesselList", {
        filter: "ContractVesselList",
        active: "all",
        isAll: 0,
        ccbm_is_active: 1,
        ccbm_is_deleted: 0,
        isSelectedColumn: 0,
        // isSelectedColumn: 1,
        fk_cb_id: this.form.fk_contract_id,
        is_withoutcb: 1,
      }),
    ];
    // Function to introduce a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    // Wait for all store actions to complete
    Promise.all(storePromises)
      .then(() => delay(2000)) // Wait for 5 seconds
      .then(() => {
        // After the delay, execute the next function
        if (
          this.$sessionsStorage.get("booking_resp_frt_enq_id") &&
          this.$sessionsStorage.get("is_new_book_resp")
        ) {
          this.getEnquiryPrcingBookingRespList(
            "Normal",
            this.$sessionsStorage.get("booking_resp_frt_enq_id"),
            this.$sessionsStorage.get("is_new_book_resp")
          );
        }
      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });
    // Other actions that need to be performed
    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.windowSize = $(window).width();
    lastVisitPage(this.$router.history.current.fullPath);
  },

  data() {
    return {
      selectDateFormat,
      vesselModal: {
        ccbm_id: '',
        fk_contract_id: '',
        vessel_name: '',
        vessel_voyage_no: '',
        vessel_sail_date: '',
        ra_number: "",
      },
      vesselError: ["Please Enter Vessel Name","Please Enter Voyage No", "Please Enter SOB Date"],
      errorVesselList: {
        vessel_name: "",
        vessel_voyage_no: "",
        vessel_sail_date: "",
      },

      dynamicVesselFields: [
        { key: "vessel_name", label: "Vessel/Voyage No", fieldType: "input", required: true, disabled: false },
        { key: "vessel_sail_date", label: "SOB Date", fieldType: "datepicker", required: false, disabled: false }],
      contractContainerArr: [
        {
          ccbm_id: 0,
          fk_cont_type_id: "",
          continer_type_name: "",
          continer_contract_rate: "",
          continer_premium_contract_rate: "",
          continer_remark: "",
          continer_tues_commitment_val: "",
          vessel_voyage_no: "",
          vessel_name: "",
          vessel_sail_date: "",
          start_date: "",
          end_date: "",
          continer_contract_selling_rate: "",

          fk_cont_type_id_err: "",
          continer_contract_rate_err: "",
          continer_remark_err: "",
          continer_premium_contract_rate_err: "",
          continer_tues_commitment_val_err: "",

          vessel_voyage_no_err: "",
          vessel_name_err: "",
          vessel_sail_date_err: "",
          start_date_err: "",
          end_date_err: "",
          continer_contract_selling_rate_err: "",
        },
      ],
      clientType: 'existing',
      newShipperForm: {
        clientId: 0,
        clientName: '',
        email: '',
        pan: '',
        gst: '',
        address: '',
      },
      newShipperErrorList: {
        clientName: 'Client name is required.',
        // email: 'Valid email is required.',
        pan: 'PAN is required.',
        gst: 'GST is required.',
        // address: 'Address is required.',
      },
      validationNewShipperErrors: {}, // Object to store field validation errors
      // Added vy Priyanshu Singh Start
      isSubmited: false,
      commodityDisabled: false,
      commodityModal: {
        commodityNewId: "",
        itemName: "",
        hsnCode: "",
      },
      CommodityError: ["Please Enter ItemName", "Please Enter HSNCode"],
      errorComodityList: {
        itemName: "",
        hsnCode: "",
      },

      contractDisabled: false,
      contractModal: {
        cb_id: 0,
        cb_contarct_no: "",
        contract_name: "",
        contract_description: "",
        start_date: "",
        end_date: "",
      },
      contractError: ["Please Enter Contract No"],
      errorContractList: {
        cb_contarct_no: "",
      },
      BookingTypeList: [
        {
          bkgval: "ON SPOT",
          bkgtxt: "ON SPOT",
        },
        {
          bkgval: "WEB QUOTE",
          bkgtxt: "WEB QUOTE",
        },
        {
          bkgval: "ON CONTRACT",
          bkgtxt: "ON CONTRACT",
        },
        {
          bkgval: "NOT APPLICABLE",
          bkgtxt: "NOT APPLICABLE",
        },
      ],
      BillingTypeList: [
        {
          inv: "1",
          int: "Local Billing Only",
        },
        {
          inv: "2",
          int: "Overseas Billing Only",
        },
        {
          inv: "3",
          int: "LOCAL AND OVERSEAS BILLING",
        },
      ],
      BookingTypeList: [
        {
          bkgval: "ON SPOT",
          bkgtxt: "ON SPOT",
        },
        {
          bkgval: "WEB QUOTE",
          bkgtxt: "WEB QUOTE",
        },
        {
          bkgval: "ON CONTRACT",
          bkgtxt: "ON CONTRACT",
        },
        {
          bkgval: "NOT APPLICABLE",
          bkgtxt: "NOT APPLICABLE",
        },
      ],
      BookingForList: [
        {
          bkgval: "Agent",
          bkgtxt: "Agent",
        },
        {
          bkgval: "Client",
          bkgtxt: "Client",
        },
      ],
      agentHandlingExpenseList: [
        {
          bkgval: "Yes",
          bkgtxt: "Yes",
        },
        {
          bkgval: "No",
          bkgtxt: "No",
        },
      ],
      CONTAINERCOUNTArr: [
        {
          ccbm_id: "",
          fk_cont_type_id: "",
          fk_currency_id: "1",
          brcm_tot_continer: "",
          brcm_rate: "",
          brcm_sell_rate: "",
          brcm_continer_remark: "",

          fk_cont_type_id_err: "",
          fk_currency_id_err: "",
          brcm_tot_continer_err: "",
          brcm_rate_err: "",
          brcm_sell_rate_err: "",
          brcm_continer_remark_err: "",
        },
      ],
      // Added vy Priyanshu Singh End

      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content: "",
        ok: "ok",
      },
      qTillList: [
        {
          qV: "1",
          qT: "Validity till Handover",
        },
        {
          qV: "2",
          qT: "Validity till Sailing",
        },
      ],
      oceanFreightTermsName: [
        {
          TermsVal: "prepaid",
          TermsText: "Prepaid",
        },
        {
          TermsVal: "collect",
          TermsText: "Collect",
        },
      ],
      firstMileBookingList: [
        {
          bkgval: "Yes",
          bkgtxt: "Yes",
        },
        {
          bkgval: "No",
          bkgtxt: "No",
        },
      ],
      deliveryModeName: [
        {
          deliveryModeVal: "CY_CY",
          deliveryModeText: "CY / CY",
        },
        {
          deliveryModeVal: "CY_RAMP",
          deliveryModeText: "CY / RAMP",
        },
        {
          deliveryModeVal: "CY_StoreDoor",
          deliveryModeText: "CY / Store Door",
        },
      ],
      formError: [
        "Please Select Transport Type",
        "Please Select Shipment Type",
        "Please Select Booking For",
        // "Please Select Client Name",
        // "Please Select Agent Name",
        "Please Select Empty Pickup",
        "Please Select Handover",
        "Please Select POL",
        "Please Select POD",
        // "Please Select FPOD",
        "Please Select Currency",
        // "Please Select Equipment",
        "Please Select Commodity Type",
        "Please Select Commodity HSN CODE",
        "Please Select Shipping Line",
        // "Please Select Agent",
        // "Please Select RA Number",
        "Please Select Branch",
        "Please Enter Free Days",
        // "Please Enter Rate Agreed",
        "Please Enter PDA",
        "Please Enter ETD",
        // "Please Enter Handover Date",
        // "Please Enter Valid For Sale",
        "Please Enter Valid Till",
        "Please Select Quotation Till",
        "Please Select Delivery Mode",
        "Please Select First Mile Booking",
        // "Please Select Vessel Name",
      ],
      errorList: {
        transport_type: "",
        shipment_type: "",
        booking_for: "",
        // agent_handling_expense: "",
        // fk_client_id: "",
        // fk_agent_id: "",
        fk_epk_id: "",
        fk_por_id: "",
        fk_pol_id: "",
        fk_pod_id: "",
        // fk_fpod_id: "",
        fk_currency_id: "",
        // fk_container_id: "",
        commodity_type: "",
        fk_commodity_id: "",
        fk_shipping_id: "",
        // fk_sales_person_id:"",
        // billing_type:"",
        // fk_agent_id: "",
        // fk_contract_id: "",
        fk_branch_id: "",
        free_days: "",
        // rate_agreed: "",
        pda: "",
        etd: "",
        // handover_date: "",
        // valid_for_sail: "",
        valid_till: "",
        quotation_till: "",
        delivery_mode: "",
        first_mile_booking: "",
        // vesselName: "",
        // voyageNo: "",
        // fk_ccbm_id: "",
      },
      form: {
        is_duplicate: 0,
        record_type:
          this.$route.params.template == 1 ? "TEMPLATE_MASTER" : "BOOKING_RESPONSE",
        is_client_template: this.$route.params.template ? this.$route.params.template : 0,
        containerTypeDet: [],
        template_name: "",
        template_valid_till: "",
        booking_no: "",
        bookingType: "",
        is_booing_response: this.$route.params.type ? this.$route.params.type : 1,
        prbr_id: 0,
        enquiry_no:
          this.$sessionsStorage.get("booking_resp_frt_enq_id") > 0
            ? this.$sessionsStorage.get("freight_enq_no")
            : null,
        enquiry_booking_no: "",
        transport_type: "EXPORT",
        shipment_type: "Sea",
        inco_term: "",
        fk_client_id: "",
        fk_agent_id: "",
        agent_handling_expense: "No",
        fk_epk_id: "",
        fk_por_id: "",
        fk_pol_id: "",
        fk_pod_id: "",
        fk_fpod_id: "",
        fk_enq_price_id: "",
        fk_container_id: "",
        fk_currency_id: "1",
        commodity_type: "",
        fk_commodity_id: "",
        fk_shipping_id: "",
        fk_sales_person_id: "",
        billing_type: "",
        other_comodity: "",
        packing_code: "",
        imdg_class: "",
        un_number: "",
        temperature_required: "",
        humidity: "",
        cargo_weight: "",
        spot_non_spot: "",
        ra_number: "",
        fk_contract_id: "",
        fk_branch_id: "",
        rate_agreed: "",
        free_days: "",
        pda: "",
        etd: "",
        bl_instruction: "",
        remarks: "",
        delivery_mode: "",
        freight_terms_mbl: "",
        freight_terms_hbl: "",
        destination_charges: "",
        destination_charges_det:"",
        first_mile_booking: "No",
        si_cut_of_date: "",
        handover_date: "",
        valid_for_sail: "",
        valid_till: "",
        quotation_till: "",
        fk_frt_enq_id: this.$sessionsStorage.get("booking_resp_frt_enq_id"),
        booking_resp_edit_type: this.$sessionsStorage.get("booking_resp_edit_type"),
        is_new_book_resp: this.$sessionsStorage.get("is_new_book_resp"),
        vesselName: "",
        voyageNo: "",
        // vessel_name: [],
        vessel_name: "",
        // vessel_voyage_no:"",
      },
      vessel_nameItems: [],
      blINSTRUCTIONList: [
        {
          text: "HOUSE BL",
          value: "HOUSE BL",
        },
        {
          text: "LINER BL",
          value: "LINER BL",
        },
        {
          text: "AS PER SHIPPER INSTRUCTION",
          value: "AS PER SHIPPER INSTRUCTION",
        },
      ],
      pdaList: [
        {
          text: "SHIPPER PDA",
          value: "SHIPPER PDA",
        },
        {
          text: "LINER PDA",
          value: "LINER PDA",
        },
        {
          text: "PRIDEL PDA",
          value: "PRIDEL PDA",
        },
        {
          text: "NOT APPLICABLE",
          value: "NOT APPLICABLE",
        },
      ],
      commodityTypeList: [
        {
          value: "Hazardous",
          text: "DANGEROUS CARGO (HAZ)",
        },
        {
          value: "Reefer",
          text: "TEMPERATUR CONTROLLED ( REEFER)",
        },
        {
          value: "Others",
          text: "GENERAL (OTHERS)",
        },
      ],
      spotList: [
        {
          value: "SPOT",
          text: "SPOT",
        },
        {
          value: "NON SPOT",
          text: "NON SPOT",
        },
      ],
      shipment_typeList: [
        {
          text: "Sea",
          value: "Sea",
        },
        {
          text: "Air",
          value: "Air",
        },
      ],
      deliveryTermsList: [
        {
          value: "ExWorks",
          text: "EXWORKS",
        },
        {
          value: "FOB",
          text: "FOB",
        },
        {
          value: "CIF",
          text: "CIF",
        },
        {
          value: "DAP",
          text: "DAP",
        },
        {
          value: "DDU",
          text: "DDU",
        },
        {
          value: "DDP",
          text: "DDP",
        },
        {
          value: "CFR",
          text: "CFR",
        },
        {
          value: "FCA",
          text: "FCA",
        },
      ],
      getCommodityData: [],
      moduelTypeList: [
        {
          text: "EXPORT",
          value: "EXPORT",
        },
        {
          text: "IMPORT",
          value: "IMPORT",
        },
        {
          text: "CROSS COUNTRY",
          value: "CRC",
        },
      ],
      validate: true,
      validateCONC: true,
    };
  },
  created() { },
  mounted() { },
  computed: {
    commodityList() {
      return this.getCommodityData;
    },
  },

  destroyed() { },
  components: {
    ModelListSelect,
    MultiSelect,
    CustomLoader,
    Multiselect,
    DatePicker,
    DynamicModal,
  },
  methods: {
    openVesselModal() {
      this.$refs.vesselModalRef.show(); // ✅ This will now work
    },
    hideVesselModal() {
      this.$refs.vesselModalRef.hide();
    },
    validateVessel() {
      let validate_new = true;
      Object.keys(this.errorVesselList).map((x, index) => {
        if (this.vesselModal[x] == "") {
          this.errorVesselList[x] = this.vesselError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addVesselVoyage() {
      this.validateVessel();
      if (this.validate != false) {
        this.contractDisabled = true;
        this.vesselModal.fk_contract_id = this.form.fk_contract_id;
        this.vesselModal.ra_number = this.form.ra_number;
        NodeLockPannelService.saveContractVessel(this.vesselModal)
          .then((response) => {
            this.isLoading = false;
            const { statusText, status, data } = response;
            if (status == 200 && data) {

              if (data.data.ccbm_id != "" && data.data.ccbm_id != undefined) {
                this.$store.dispatch("common/setAllContractBasedVesselList", {
                  filter: "ContractVesselList",
                  active: "all",
                  isAll: 0,
                  ccbm_is_active: 1,
                  ccbm_is_deleted: 0,
                  isSelectedColumn: 0,
                  // isSelectedColumn: 1,
                  fk_cb_id: this.form.fk_contract_id,
                  is_withoutcb: 1,
                });
                if (data.status == true) {
                  this.alert.content = data.message;
                } else {
                  this.alert.content = data.message;
                  this.vesselModal.ccbm_id = 0;
                  this.vesselModal.vessel_name = "";
                }
              } else {
                this.alert.content = data.message;
              }
              this.hideVesselModal();
              this.contractDisabled = false;
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {
            console.log("Catch on saveVessel Error: ", error);
            this.isLoading = false;
          });
      }
    },

    addVesselVoyageBak(formData) {
      // formData is the object from the modal
      console.log("Saved Vessel/Voyage:", formData);

      // You can now process it or send it to your API
      // e.g., this.$store.dispatch('saveContract', formData)
    },
    validateDegreeBak(key) {
      // RegExp to match up to 6 digits, no decimals
      const regex = /^\d{0,3}$/;

      // If the current value doesn't match the regex, trim it
      if (!regex.test(this.form[key])) {
        // Revert to the valid part of the number
        const match = this.form[key].match(/^\d{0,3}/);
        if (match) {
          this.form[key] = match[0];
        } else {
          this.form[key] = null;
        }
      }
    },
    validateDegree(key) {
      // RegExp to match negative numbers, between -50 and 0
      let regex = /^\d{0,3}$/;
      if (key === "temperature_required") {
        regex = /^-?\d{0,3}$/;
      } else {
        regex = /^\d{0,3}$/;
      }

      // If the current value doesn't match the regex, trim it
      if (!regex.test(this.form[key])) {
        // Revert to the valid part of the number
        let match = this.form[key].match(/^\d{0,3}/);
        if (key === "temperature_required") {
          match = this.form[key].match(/^-?\d{0,3}/);
        } else {
          match = this.form[key].match(/^\d{0,3}/);
        }
        if (match) {
          this.form[key] = match[0];
        } else {
          this.form[key] = null;
        }
      }

      if (key === "temperature_required") {
        // Ensure the value is not greater than -50
        if (this.form[key] < -50) {
          this.form[key] = "";
        }
      }
    },

    validateRateAgreed() {
      // RegExp to match up to 6 digits before decimal and up to 3 decimal places
      const regex = /^\d{0,7}(\.\d{0,3})?$/;

      // If the current value doesn't match the regex, trim it
      if (!regex.test(this.form.rate_agreed)) {
        // Revert to the valid part of the number
        const match = this.form.rate_agreed.match(/^\d{0,7}(\.\d{0,3})?/);
        if (match) {
          this.form.rate_agreed = match[0];
        } else {
          this.form.rate_agreed = null;
        }
      }
    },
    validateCONCDetail() {
      let validate_new = true;
      let errCount = 0;

      let MainARR = this.CONTAINERCOUNTArr;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].fk_cont_type_id == "") {
          this.CONTAINERCOUNTArr[j].fk_cont_type_id_err =
            "Container Type " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.CONTAINERCOUNTArr[j].fk_cont_type_id_err = "";
          validate_new = true;
        }

        if (MainARR[j].brcm_tot_continer == "") {
          this.CONTAINERCOUNTArr[j].brcm_tot_continer_err =
            "Container Count " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.CONTAINERCOUNTArr[j].brcm_tot_continer_err = "";
          validate_new = true;
        }

        if (MainARR[j].fk_currency_id == "") {
          this.CONTAINERCOUNTArr[j].fk_currency_id_err =
            "Currency " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.CONTAINERCOUNTArr[j].fk_currency_id_err = "";
          validate_new = true;
        }
        if (MainARR[j].brcm_rate == "" || MainARR[j].brcm_rate <= 0) {
          if (MainARR[j].brcm_rate == "") {
            this.CONTAINERCOUNTArr[j].brcm_rate_err =
              "Buying Ocean Freight " + parseInt(j + 1) + " Field is Required";
            validate_new = false;
            ++errCount;
          } else if (MainARR[j].brcm_rate <= 0) {
            this.CONTAINERCOUNTArr[j].brcm_rate_err =
              "Please Enter Correct Buying Ocean Freight " + parseInt(j + 1) + " Amount";
            validate_new = false;
            ++errCount;
          }

          // break;
        } else {
          this.CONTAINERCOUNTArr[j].brcm_rate_err = "";
          validate_new = true;
        }

        if (MainARR[j].brcm_sell_rate == "" || MainARR[j].brcm_sell_rate <= 0) {
          if (MainARR[j].brcm_sell_rate == "") {
            this.CONTAINERCOUNTArr[j].brcm_sell_rate_err =
              "Selling Ocean Freight " + parseInt(j + 1) + " Field is Required";
            validate_new = false;
            ++errCount;
          } else if (MainARR[j].brcm_sell_rate <= 0) {
            this.CONTAINERCOUNTArr[j].brcm_sell_rate_err =
              "Please Enter Correct Selling Ocean Freight " + parseInt(j + 1) + " Amount";
            validate_new = false;
            ++errCount;
          }

          // break;
        } else {
          this.CONTAINERCOUNTArr[j].brcm_sell_rate_err = "";
          validate_new = true;
        }
      }
      // alert(errCount);
      if (errCount > 0) {
        this.validateCONC = false;
      } else {
        this.validateCONC = true;
      }
    },
    addContractContainerRate() {
      let obj = {
        ccbm_id: 0,
        fk_cont_type_id: "",
        fk_currency_id: "",
        continer_type_name: "",
        continer_contract_rate: "",
        continer_premium_contract_rate: "",
        continer_remark: "",
        continer_tues_commitment_val: "",
        vessel_voyage_no: "",
        vessel_name: "",
        vessel_sail_date: "",
        start_date: "",
        end_date: "",
        continer_contract_selling_rate: "",

        fk_cont_type_id_err: "",
        fk_currency_id_err: "",
        continer_contract_rate_err: "",
        continer_premium_contract_rate_err: "",
        continer_remark_err: "",
        continer_tues_commitment_val_err: "",
        vessel_voyage_no_err: "",
        vessel_name_err: "",
        vessel_sail_date_err: "",
        start_date_err: "",
        end_date_err: "",
        continer_contract_selling_rate_err: "",
      };
      this.contractContainerArr.push(obj);
    },
    removeContractContainerRate(index) {
      this.contractContainerArr.splice(index, 1);
    },
    validateContractContainerDetail() {
      let validate_new = true;
      let errCount = 0;

      let MainARR = this.contractContainerArr;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].fk_cont_type_id == "") {
          this.contractContainerArr[j].fk_cont_type_id_err =
            "Container Type " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.contractContainerArr[j].fk_cont_type_id_err = "";
          validate_new = true;
        }

        if (MainARR[j].fk_currency_id == "") {
          this.contractContainerArr[j].fk_currency_id_err =
            "Currecny Name " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.contractContainerArr[j].fk_currency_id_err = "";
          validate_new = true;
        }

        if (MainARR[j].continer_premium_contract_rate == "") {
          this.contractContainerArr[j].continer_premium_contract_rate_err =
            "Contract Rate " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.contractContainerArr[j].continer_premium_contract_rate_err = "";
          validate_new = true;
        }

        // if (MainARR[j].continer_contract_selling_rate == "") {
        //   this.contractContainerArr[j].continer_contract_selling_rate_err =
        //     "Contract Selling Rate Values " + parseInt(j + 1) + " Field is Required";
        //   validate_new = false;
        //   ++errCount;
        // } else {
        //   this.contractContainerArr[j].continer_contract_selling_rate_err = "";
        //   validate_new = true;
        // }


        if (MainARR[j].vessel_name == "") {
          this.contractContainerArr[j].vessel_name_err =
            "Contract Vessel Name " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.contractContainerArr[j].vessel_name_err = "";
          validate_new = true;
        }

        if (MainARR[j].vessel_sail_date == "") {
          this.contractContainerArr[j].vessel_sail_date_err =
            "Contract Vessel Sail Date " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.contractContainerArr[j].vessel_sail_date_err = "";
          validate_new = true;
        }
      }
      if (errCount > 0) {
        this.validateCONC = false;
      } else {
        this.validateCONC = true;
      }
    },
    addContainerCount() {
      let obj = {
        ccbm_id: "",
        fk_cont_type_id: "",
        fk_currency_id: "1",
        brcm_tot_continer: "",
        brcm_rate: "",
        brcm_sell_rate: "",
        brcm_continer_remark: "",

        fk_cont_type_id_err: "",
        fk_currency_id_err: "",
        brcm_tot_continer_err: "",
        brcm_rate_err: "",
        brcm_sell_rate_err: "",
        brcm_continer_remark_err: "",
      };
      this.CONTAINERCOUNTArr.push(obj);
    },
    removeContainerCount(index) {
      this.CONTAINERCOUNTArr.splice(index, 1);
    },
    getContractNo(fk_contract_id) {
      let ContractList = this.$store.getters["common/getAllContractList"].filter((x) => {
        return x.value == fk_contract_id;
      });
      if (ContractList.length > 0) {
        this.form.ra_number = ContractList[0].label;
        this.contractModal.cb_contarct_no = ContractList[0].label;
        this.contractModal.cb_id = ContractList[0].value;
        this.$store.dispatch("common/setAllContractBasedVesselList", {
          filter: "ContractVesselList",
          active: "all",
          isAll: 0,
          ccbm_is_active: 1,
          ccbm_is_deleted: 0,
          isSelectedColumn: 0,
          // isSelectedColumn: 1,
          fk_cb_id: ContractList[0].value,
          is_withoutcb: 1,
        });
        // this.CONTAINERCOUNTArr=this.$store.getters["common/getAllContractBasedVesselList"];
      }
    },
    SelectMultiVesselName(vessel_nameItems) {
      this.vessel_nameItems = vessel_nameItems;
      this.form.vessel_name = vessel_nameItems;
      this.getAllContractBasedVesselList(vessel_nameItems); // pass full array
    },

    getAllContractBasedVesselListBak(selectedItems) {
      const allVessels = this.$store.getters["common/getAllContractBasedVesselList"];
      this.CONTAINERCOUNTArr = [];

      selectedItems.forEach((item) => {
        const match = allVessels.find((x) => x.value === item.ccbm_id);
        console.log('match=>', match, item.ccbm_id)
        if (match) {
          const vesselMatches = allVessels.filter((x) => x.ccbm_id === match.ccbm_id);
          this.CONTAINERCOUNTArr.push(...vesselMatches);

          // Optional: update first match details (you can customize how to handle multiples)
          this.form.fk_ccbm_id = match.value;
          this.form.vesselName = match.vessel_name;
          this.form.voyageNo = match.vessel_voyage_no;
        }
      });

      // Optional: remove duplicates
      this.CONTAINERCOUNTArr = [...new Map(this.CONTAINERCOUNTArr.map(item => [item.value, item])).values()];
      console.log('this.CONTAINERCOUNTArr=>', this.CONTAINERCOUNTArr);
      console.log('this.selectedItems=>', selectedItems);
      console.log('this.allVessels=>', allVessels);
    },
    getAllContractBasedVesselList(ccbm_id) {
      console.log(ccbm_id);
      let ContractVesselList = this.$store.getters["common/getAllContractBasedVesselList"].filter((x) => {
        return x.value == ccbm_id;
      });
      console.log('ContractVesselList=>', ContractVesselList)
      if (ContractVesselList.length > 0) {
        let vessel_name = ContractVesselList[0].vessel_name;
        let VesselList = this.$store.getters["common/getAllContractBasedVesselList"].filter((x) => {
          return x.vessel_name == vessel_name;
        });
        console.log('vessel_name=>', vessel_name)
        console.log('VesselList=>', VesselList)
        console.log('ContractVesselList=>', ContractVesselList)
        this.form.etd = ContractVesselList[0].vessel_sail_date;
        this.form.fk_ccbm_id = ContractVesselList[0].value,
        this.form.vessel_name = ContractVesselList[0].vessel_name;
        this.form.vesselName = ContractVesselList[0].vessel_name;
        this.form.voyageNo = ContractVesselList[0].vessel_voyage_no;
        // this.CONTAINERCOUNTArr=ContractVesselList;
        // this.CONTAINERCOUNTArr = VesselList;
      }
    },
    goBack() {
      window.history.go(-1);
    },
    getCommodityList(event, vmodelArray) {
      let vehicle_drive = {
        value: event,
      };

      let self = this;

      if (event != "") {
        GlobalGetCommodity2(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    chnageShipper(clientType) {
      if (this.clientType == 'new') {
        this.$store.dispatch(
          "common/setAllClientList",
          JSON.stringify({ itemCode: "ClientList", isKYC: "Yes", isBRF: 0 })
        );
      } else if (this.clientType == 'existing') {
        this.$store.dispatch("common/setAllClientList", JSON.stringify({ itemCode: "ClientList", isKYC: "No", isBRF: 1 }));
      }

    },
    addShipperModal() {
      this.$refs.ShipperModal.show();
    },
    closeShipperModal() {
      this.clearNewShipperForm();
      this.validationNewShipperErrors = {}; // Reset validation errors on modal close
      this.$refs.ShipperModal.hide();
    },

    // Helper function to check if a value is empty or invalid
    isEmpty(value) {
      return value === "" || value === undefined || value === null;
    },
    // GST validation with state code
    isValidGST(gst) {
      this.validationNewShipperErrors.gst = '';
      const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      let val = gstRegex.test(gst);
      if (!val) {
        this.setError('gst', 'Pls Enter Valid GST No');
      }
      return val;
    },

    // PAN validation
    isValidPAN(pan) {
      var paninformat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$");
      this.validationNewShipperErrors.pan = '';
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      let val = paninformat.test(pan);
      if (!val) {
        this.setError('pan', 'Pls Enter Valid PAN No');
      }
      return val;
    },

    isValidEmail(email) {
      this.validationNewShipperErrors.email = '';
      // Simple email validation regex
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      console.log('email,', emailPattern.test(email), email)
      let val = emailPattern.test(email);
      if (!val) {
        this.setError('email', 'Pls Enter Valid Email');
      }
      return val;
    },
    // Helper function to set error messages for specific fields
    setError(field, message) {
      this.validationNewShipperErrors[field] = message;
    },
    validateNewShipperForm() {
      // Reset validation errors
      this.validationNewShipperErrors = {};

      // Define validation rules with corresponding error messages
      const fieldsToValidate = {
        clientName: this.newShipperErrorList.clientName,
        email: this.newShipperErrorList.email,
        pan: this.newShipperErrorList.pan,
        gst: this.newShipperErrorList.gst,
        // address: this.newShipperErrorList.address
      };

      // Validate each field and set errors if necessary
      for (const [field, message] of Object.entries(fieldsToValidate)) {
        console.log('this.newShipperForm[field]=>', this.newShipperForm, this.newShipperForm[field])
        if (field === "email") {
          if (this.isEmpty(this.newShipperForm[field]) || !this.isValidEmail(this.newShipperForm[field])) {
            this.setError(field, message);
          }
        } else if (field === "gst") {
          if (this.isEmpty(this.newShipperForm[field]) || !this.isValidGST(this.newShipperForm[field])) {
            this.setError(field, "Please enter a valid GST number with a State code");
          }
        } else if (field === "pan") {
          if (this.isEmpty(this.newShipperForm[field]) || !this.isValidPAN(this.newShipperForm[field])) {
            this.setError(field, "Please enter a valid PAN number");
          }
        } else if (this.isEmpty(this.newShipperForm[field])) {
          this.setError(field, message);
        }
      }
      // Count only keys with non-empty values
      const errorCount = Object.keys(this.validationNewShipperErrors).filter(key => this.validationNewShipperErrors[key]).length;

      // Return the count of validation errors
      return errorCount;
    },
    clearNewShipperForm() {
      // Clear form fields and validation errors
      this.newShipperForm = {
        clientName: '',
        email: '',
        pan: '',
        gst: '',
        address: '',
      };
      this.validationNewShipperErrors = {};
    },
    saveShipper() {
      let shipperErr = this.validateNewShipperForm();
      console.log('shipperErr=>', shipperErr);
      console.log('this.newShipperForm', this.newShipperErrorList, this.validationNewShipperErrors)

      if (shipperErr == 0) {
        NodeLockPannelService.upsertShipper(this.newShipperForm)
          .then((response) => {
            const { data, status, statusText } = response;
            // console.log("data PS=>", data);

            if (status == 200 && data.status == true) {
              this.$store.dispatch("common/setAllClientList", JSON.stringify({ itemCode: "ClientList", isKYC: "No", isBRF: 1 }));

              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log("Catch on getBookingResp Error: ", error);
          });
      }
    },
    getAgentHandlingExpense(fk_agent_id) {
      if (fk_agent_id == '159' || fk_agent_id == '86') {

      }
    },

    getClearContractNoErr() {
      this.CONTAINERCOUNTArr = [];
      this.form.fk_contract_id = "";
      this.form.ra_number = "";
      this.form.vessel_name = "";
      // this.form.vessel_name = [];
      this.errorList.bookingType = "";
      // this.errorList.fk_contract_id = "";
      // this.errorList.vessel_name = "";
      // this.errorList.vessel_voyage_no = "";
      this.addContainerCount();
    },
    clearError() {
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList", isKYC: "Yes", isBRF: 0 })
      );
        this.errorList = {
          transport_type: "",
          shipment_type: "",
          booking_for: "",
          // agent_handling_expense: "",
          // fk_client_id: "",
          // fk_agent_id: "",
          fk_epk_id: "",
          fk_por_id: "",
          fk_pol_id: "",
          fk_pod_id: "",
          // fk_fpod_id: "",
          fk_currency_id: "",
          // fk_container_id: "",
          commodity_type: "",
          fk_commodity_id: "",
          fk_shipping_id: "",
          // fk_sales_person_id:"",
          // billing_type:"",
          // fk_agent_id: "",
          // fk_contract_id: "",
          fk_branch_id: "",
          free_days: "",
          // rate_agreed: "",
          pda: "",
          etd: "",
          // handover_date: "",
          // valid_for_sail: "",
          valid_till: "",
          quotation_till: "",
          delivery_mode: "",
          // vesselName: "",
          // voyageNo: "",
        }
    },
    validateBookingResp() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.form[x] == "" || this.form[x] == undefined || this.form[x] == null) {
          this.errorList[x] = this.formError[index];
          validate_new = false;
        }
      });
      console.log('Enter Booking Error', this.$route.params.type, this.$route.params.template)
      // Additional validation for template_name and template_valid_till when route parameter is 1
      if (this.$route.params.template == 1) {
        if (
          this.form.template_name == "" ||
          this.form.template_name == undefined ||
          this.form.template_name == null
        ) {
          this.errorList["template_name"] = "Template Name is required";
          validate_new = false;
        }

        // if (
        //   this.form.vessel_name  == "" ||
        //   this.form.vessel_name  == undefined ||
        //   this.form.vessel_name  == null
        // ) {
        //   this.errorList["vessel_name"] = "Select Vessel Name is required";
        //   validate_new = false;
        // }

        if (
          this.form.template_valid_till == "" ||
          this.form.template_valid_till == undefined ||
          this.form.template_valid_till == null
        ) {
          this.errorList["template_valid_till"] = "Template Valid Till is required";
          validate_new = false;
        }
      }
      if (this.form.bookingType == "ON CONTRACT") {
        // alert('ON CONTRACT')
        // alert(this.form.fk_contract_id)
        if (
          this.form.fk_contract_id == "" ||
          this.form.fk_contract_id == undefined ||
          this.form.fk_contract_id == null
        ) {
          this.errorList["fk_contract_id"] = "Select Contract No is required";
          validate_new = false;
        }

      

        // if (
        //   this.form.vessel_voyage_no  == "" ||
        //   this.form.vessel_voyage_no  == undefined ||
        //   this.form.vessel_voyage_no  == null
        // ) {
        //   this.errorList["vessel_voyage_no"] = "Select Vessel Voyage No is required";
        //   validate_new = false;
        // }
      }
      if (this.$route.params.type == 1) {
        if (
          this.form.booking_for == "Agent" &&
          (this.form.fk_agent_id == "" ||
            this.form.fk_agent_id == undefined ||
            this.form.fk_agent_id == null)
        ) {
          console.log('Enter Agent Error')
          this.errorList["fk_agent_id"] = "Select Agent Name Filed is required";
          validate_new = false;
        }

        if (
          this.form.fk_agent_id &&
          (this.form.agent_handling_expense == "" ||
            this.form.agent_handling_expense == undefined ||
            this.form.agent_handling_expense == null)
        ) {
          console.log('Enter Agent Error')
          this.errorList["agent_handling_expense"] = "Select AGENT HANDLING EXPENSES to PRIDEL Filed is required";
          validate_new = false;
        }

        if (
          this.form.booking_for == "Client" &&
          (this.form.fk_client_id == "" ||
            this.form.fk_client_id == undefined ||
            this.form.fk_client_id == null)
        ) {
          console.log('Enter Client Error')
          this.errorList["fk_client_id"] = "Select Shipper Name Filed is required";
          validate_new = false;
        }
      }
      if (this.$route.params.type == 0) {
        if (
          this.form.booking_no == "" ||
          this.form.booking_no == undefined ||
          this.form.booking_no == null
        ) {
          console.log('Enter Booking Error')
          this.errorList["booking_no"] = "Line Booking No is required";
          validate_new = false;
        }


        if (
          this.form.booking_for == "Agent" &&
          (this.form.fk_agent_id == "" ||
            this.form.fk_agent_id == undefined ||
            this.form.fk_agent_id == null)
        ) {
          console.log('Enter Agent Error')
          this.errorList["fk_agent_id"] = "Select Agent Name Filed is required";
          validate_new = false;
        }

        if (
          this.form.fk_agent_id &&
          (this.form.agent_handling_expense == "" ||
            this.form.agent_handling_expense == undefined ||
            this.form.agent_handling_expense == null)
        ) {
          console.log('Enter Agent Error')
          this.errorList["agent_handling_expense"] = "Select AGENT HANDLING EXPENSES to PRIDEL Filed is required";
          validate_new = false;
        }

        if (
          this.form.booking_for == "Client" &&
          (this.form.fk_client_id == "" ||
            this.form.fk_client_id == undefined ||
            this.form.fk_client_id == null)
        ) {
          console.log('Enter Client Error')
          this.errorList["fk_client_id"] = "Select Shipper Name Filed is required";
          validate_new = false;
        }
      }
      console.log('this.errorList validate_new=>', this.errorList,validate_new);
      console.log('this.form=>', this.form);
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },

    saveBookingResp(is_client_template) {
      this.validateBookingResp();
      this.validateCONCDetail();
      console.log('this.validate=>', this.validate,this.errorList);
      console.log('this.validateCONC=>', this.validateCONC,this.contractContainerArr);
      if (this.validate) {
        if (this.validateCONC == false) {
          return false;
        }
        this.isLoading = true;
        // Handle form submission
        this.form.is_client_template = is_client_template;
        if (is_client_template == 0) {
          this.form.record_type = 'BOOKING_RESPONSE';
        }
        this.form.is_duplicate = this.$sessionsStorage.get("is_duplicate")
          ? this.$sessionsStorage.get("is_duplicate")
          : 0;
        this.form.fk_frt_enq_id = this.$sessionsStorage.get("booking_resp_frt_enq_id");
        this.form.booking_resp_edit_type = this.$sessionsStorage.get("booking_resp_edit_type");
        this.form.containerTypeDet =
          this.CONTAINERCOUNTArr.length > 0
            ? JSON.stringify(this.CONTAINERCOUNTArr)
            : JSON.stringify([]);
        this.isSubmited = true;
        console.log('this.form=>', this.form);
        // return false;
        NodeLockPannelService.saveNewBookingResp(this.form)
          .then((response) => {
            const { data, status, statusText } = response;

            if (status == 200 && data) {
              this.isSubmited = false;
              this.alert.content = data.MSG;
              // this.$refs["addPop"].open();
              if (this.$route.params.template == 0) {
                if (this.$route.params.type == 1) {
                  this.goFreightEnq();
                } else if (this.$route.params.type == 0) {
                  this.goConsoleBooking();
                }
              } else {
                this.goBRFTemplate();
              }
            }
            this.isSubmited = false;
            this.isLoading = false;
          })
          .catch((error) => {
            this.isSubmited = false;
            console.log("Catch on saveBookingResp Error: ", error);
          });
      } else {
        this.isSubmited = false;
        // Show validation errors to the user
        console.log('this.form=>', this.form);
        console.log("Validation errors:", this.errorList);
      }
    },
    goBRFTemplate() {
      this.$router.push({
        path: "/booking-resp-template",
      });
    },
    goFreightEnq() {
      this.$router.push({
        path: "/enqPrice/FreightEnq",
      });
    },
    goConsoleBooking() {
      this.$router.push({
        path: "/consoleBooking",
      });
    },

    getEnquiryPrcingBookingRespList(type, prbr_id, is_new_book_resp) {
      this.isLoading = true;

      NodeLockPannelService.getSingleNewBookingResp(prbr_id)
        .then((response) => {
          this.isLoading = false;
          const { data, status, success } = response;

          if (status == 200 && data && data.success == true) {
            this.form = data.data;
            this.vessel_nameItems = data.data.vessel_name;
            this.form.booking_for = data.data.booking_response_container_map.length > 0 ? data.data.booking_response_container_map[0].console_booking_response_relation.booking_for : null,
              this.form.fk_contract_id = parseInt(data.data.fk_contract_id);
            this.CONTAINERCOUNTArr = data.data.containerTypeDet
              ? JSON.parse(data.data.containerTypeDet)
              : [];
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPrerequisiteList Error: ", error);
          this.isLoading = false;
        });
    },
    // Added By Priyanshu Singh Start
    openCommodityModal() {
      this.isLoading = false;
      this.$refs["Commodity-modal"].show();
      this.commodityDisabled = false;
    },
    hideCommodityModal() {
      this.$refs["Commodity-modal"].hide();
      this.isLoading = false;
      this.commodityDisabled = false;
    },
    validateCommodity() {
      let validate_new = true;
      Object.keys(this.errorComodityList).map((x, index) => {
        if (this.commodityModal[x] == "") {
          this.errorComodityList[x] = this.CommodityError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    getCurrencyName(fk_currency_id) {
      let CurrencyArr = this.$store.getters["common/getAllCurrencyList"].filter((x) => {
        return x.currency_id == fk_currency_id;
      });
      if (CurrencyArr.length > 0) {
        this.form.currency_name = CurrencyArr[0].currencyCode;
      }
    },
    getEnquiryPrcingList() {
      let payload = {
        itemCode: "Single_enq_price",
        enq_price_id: 0,
      };
      LeadService.getAllEnqPricingList(payload)
        .then((response) => {
          this.isLoading = false;
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.getCommodityData) {
              this.getCommodityData = data.getCommodityData;
            }
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("Catch on Single Lead Error: ", error);
        });
    },
    addCommodity() {
      this.validateCommodity();
      if (this.validate != false) {
        this.commodityModal.type = "Normal";
        this.commodityDisabled = true;

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addCommodity_VP.php`,
          data: JSON.stringify(this.commodityModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.commodityNewId != "" && data.commodityNewId != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  this.commodityModal.commodityNewId = "";
                  this.commodityModal.itemName = "";
                  this.commodityModal.hsnCode = "";
                  if (data.CommodityData.length > 0) {
                    this.getCommodityData = data.CommodityData;
                  } else {
                    this.getCommodityData = [];
                  }
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.hideCommodityModal();
              this.commodityDisabled = false;
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => { });
      }
    },

    openContractModal() {
      this.isLoading = false;
      this.$refs["Contract-modal"].show();
      this.contractDisabled = false;
      this.contractContainerArr = this.$store.getters['common/getAllContractBasedVesselList'];
    },
    hideContractModal() {
      this.$refs["Contract-modal"].hide();
      this.isLoading = false;
      this.contractDisabled = false;
      this.contractModal = {
        cb_id: 0,
        cb_contarct_no: "",
        contract_name: "",
        contract_description: "",
        start_date: "",
        end_date: "",
      };
    },


    validateContract() {
      let validate_new = true;
      Object.keys(this.errorContractList).map((x, index) => {
        if (this.contractModal[x] == "") {
          this.errorContractList[x] = this.contractError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addContract() {
      this.validateContractContainerDetail();
      this.validateContract();
      if (this.validate != false) {
        this.contractDisabled = true;
        this.contractModal.is_email_send = 1;
        this.contractModal.contractContainerArr = this.contractContainerArr;

        NodeLockPannelService.saveContract(this.contractModal)
          .then((response) => {
            this.isLoading = false;
            const { statusText, status, data } = response;
            console.log("response=>", data);
            if (status == 200 && data) {
              this.$store.dispatch("common/setAllContractList", {
                filter: "ContractList",
                active: "all",
                isAll: 1,
                cb_is_active: 1,
                cb_is_deleted: 0,
                isSelectedColumn: 1,
              });
              if (data.data.cb_id != "" && data.data.cb_id != undefined) {
                if (data.status == true) {
                  this.alert.content = data.message;
                } else {
                  this.alert.content = data.message;
                  this.contractModal.cb_id = 0;
                  this.contractModal.cb_contarct_no = "";
                }
              } else {
                this.alert.content = data.message;
              }
              this.hideContractModal();
              this.contractDisabled = false;
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {
            console.log("Catch on saveContract Error: ", error);
            this.isLoading = false;
          });
      }
    },
    // Added By Priyanshu Singh End
  },
};
</script>

<style>
.formCard {
  /* Custom styling for the card */
}

.table-header {
  background-color: #f8f9fa;
  font-weight: bold;
}

.w-90 .modal-dialog {
  max-width: 90% !important;
  margin: 0 auto !important;
}

body {
  background-color: #f8f9fa;
}

.b-container {
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// newBookingResp.vue?3805ad38